import { useEffect, useRef, useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Label } from 'reactstrap';

const options = [
    {
        label: 'Lowest Bid First',
        value: 'amount_asc',
        icon: 'ri-sort-asc',
    },
    {
        label: 'Highest Bid First',
        value: 'amount_desc',
        icon: 'ri-sort-desc',
    },
];

const SortingComponent = ({
    t,
    onChange,
}) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedSort, setSelectedSort] = useState('amount_asc');

    const isFirstRender = useRef(true);

    const toggle = () => setDropdownOpen((prevState) => !prevState);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (selectedSort && onChange) {
            onChange(selectedSort);
            setDropdownOpen(false);
        }
    }, [
        selectedSort,
        onChange,
    ]);

    return (
        <div className="sorting-component">
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle
                    caret
                    color="secondary"
                    outline
                    className="d-flex align-items-center justify-content-between"
                >
                    <i className="ri-sort-desc me-2" />
                    <span>
                        {t('Sort by')}
                    </span>
                </DropdownToggle>

                <DropdownMenu className="dropdown-menu-end" right>
                    {options.map((option) => (
                        <DropdownItem
                            key={option.value}
                            onClick={() => setSelectedSort(option.value)}
                            className="d-flex justify-content-start align-items-center"
                        >
                            {selectedSort === option.value && <i className="ri-check-line me-1 font-size-20" />}
                            <i className={`${option.icon} me-2 font-size-20`} />
                            <Label style={{ cursor: 'pointer' }} className="mb-0">
                                {t(option.label)}
                            </Label>
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>
        </div>
    );
};

export default withNamespaces()(
    SortingComponent
);
